import React from 'react';

import { IconType } from 'react-icons/lib';

import { Container, ContainerWhite } from './styles';

import Vimeo from '../../components/Vimeo';
import VideoGallery from '../../components/VideoGallery';
import ImageGallery from '../../components/ImageGallery';
import Speakers from '../Speakers';
import { usePlatformData } from '../../hooks/Platform';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}
const Sobre: React.FC = () => {
  const {platform} = usePlatformData();
    return (
      <>
  
  
        <Container>
      <h2>{platform?.infoTitle || ''}</h2>
  
          <div style={{width:'100%'}}>
            <p dangerouslySetInnerHTML={{__html: platform?.infoDescription || ''}}/>
          </div>
  
   
        </Container>
      </>
    );
  };
  export default Sobre;
